import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { HERO_IMG } from "../../lib/content";

const up = (d) => ({
  initial: { opacity: 0, y: 28 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay: d, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative isolate flex min-h-[92vh] items-end overflow-hidden bg-cs-navy">
    <motion.img
      src={HERO_IMG}
      alt="Chantier propre et ordonné après le passage de Stop Cheni"
      className="absolute inset-0 -z-20 h-full w-full object-cover"
      initial={{ scale: 1.08 }}
      animate={{ scale: 1 }}
      transition={{ duration: 1.8, ease: "easeOut" }}
    />
    <div className="absolute inset-0 -z-10 bg-gradient-to-r from-cs-navy via-cs-navy/85 to-cs-navy/30" />
    <div className="absolute inset-x-0 bottom-0 -z-10 h-40 bg-gradient-to-t from-cs-navy/70 to-transparent" />

    <div className="mx-auto w-full max-w-6xl px-5 pb-20 pt-32 sm:px-8 md:pb-28">
      <motion.div {...up(0.1)} className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-white/80 backdrop-blur">
        <MapPin className="h-3.5 w-3.5 text-cs-yellow" /> Vaud · Suisse
      </motion.div>
      <motion.h1 {...up(0.2)} data-testid="hero-title" className="font-display text-4xl font-extrabold leading-[1.02] tracking-tighter text-white sm:text-5xl lg:text-6xl">
        Stop Cheni
      </motion.h1>
      <motion.p {...up(0.32)} data-testid="hero-slogan" className="mt-5 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-cs-yellow sm:text-3xl lg:text-4xl">
        Fini le cheni.
      </motion.p>
      <motion.div {...up(0.44)} data-testid="hero-tagline" className="mt-5 max-w-xl text-base text-white/80 md:text-lg">
        Nettoyage &amp; débarras de chantiers, bureaux et locaux – Région lausannoise
      </motion.div>
      <motion.div {...up(0.56)} className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
        <a href="#devis" data-testid="hero-cta-button" className="btn-accent group px-7 py-4 text-base">
          Devis gratuit en 48 h
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
        <a href="#services" data-testid="hero-services-link" className="nav-link w-fit text-sm font-semibold text-white/85">
          Découvrir nos services
        </a>
      </motion.div>
    </div>
  </section>
);
